// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.q-toolbar[data-v-db92f36e] {\r\n  margin: 20px;\n}\n.q-toolbar-buttons[data-v-db92f36e] {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n\r\n  display: flex;\r\n  line-height: 15px;\n}\n.q-toolbar-btn[data-v-db92f36e] {\r\n  margin-left: 3px;\r\n  margin-right: 3px;\n}\r\n", ""]);
// Exports
module.exports = exports;
